import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { IconButton } from '../../../layout/form';
import { logOut, registerRoutes } from '../../../func';
import M from '@materializecss/materialize';
import { useRouteMatch } from 'react-router-dom/cjs/react-router-dom.min';
import Axios from 'axios';
import { useDispatch } from 'react-redux';

const AccountingTab = ({ outboundCheckPayee, pharmacyId, refresh }) => {
  const { path } = useRouteMatch();
  const dispatch = useDispatch();
  const authData = useMemo(
    () => JSON.parse(localStorage.getItem('auth_data')),
    []
  );

  const modal = useRef(null);
  const displayTable = useRef(null);

  const initValues = () => ({
    outboundCheckPayee: '',
  });

  const [values, setValues] = useState(initValues());

  const networkCalls = useMemo(
    () =>
      registerRoutes(
        {
          updateOutboundCheckPayee: {
            func: (pharmacyId, outboundCheckPayee) => {
              Axios.put('/api/v2/pharmacy/update/one/outboundcheckpayee', {
                ...authData,
                pharmacyId,
                outboundCheckPayee,
              })
                .then(result => {
                  dispatch(result.data);
                  refresh();
                })
                .catch(logOut);
            },
            type: 'u',
          },
        },
        path
      ),
    [path]
  );

  useEffect(() => {
    const { current } = modal;
    M.Modal.init(current, {
      onCloseEnd: () => setValues(initValues()),
      onOpenEnd: () => M.updateTextFields(),
    });
    return () => {
      M.Modal.getInstance(current)?.destroy();
    };
  }, [modal.current]);

  const autoAdjustHeights = () => {
    const { current } = displayTable;
    if (!current) return;

    const labelElements = current.querySelectorAll('table#t-labels>tbody>tr');
    const valueElements = current.querySelectorAll('table#t-values>tbody>tr');
    labelElements?.forEach((label, index) => {
      valueElements[index].style.height = `${label.clientHeight}px`;
    });
  };

  useEffect(() => {
    autoAdjustHeights();
    window.addEventListener('resize', autoAdjustHeights);
    return () => window.removeEventListener('resize', autoAdjustHeights);
  }, [displayTable.current]);

  const getModal = () =>
    modal.current ? M.Modal.getInstance(modal.current) : null;

  const openModal = useCallback(() => {
    setValues({ outboundCheckPayee: outboundCheckPayee || '' });
    getModal()?.open();
  }, [outboundCheckPayee]);

  const closeModal = () => getModal()?.close();

  const openEditModal = e => {
    e?.preventDefault();
    openModal();
  };

  const onChange = ({ target: { id, value } }) =>
    setValues(prev => ({ ...prev, [id]: value }));

  const updateAccountingInfo = e => {
    e?.preventDefault();
    const { outboundCheckPayee } = values;
    networkCalls.updateOutboundCheckPayee(pharmacyId, outboundCheckPayee);
  };

  return (
    <div style={{ padding: '1vw' }}>
      <div className="row">
        <IconButton icon="edit" onClick={openEditModal} />
      </div>
      <div ref={displayTable} className="row">
        <div className="col s4 m3 l2">
          <table id="t-labels">
            <tbody>
              <tr>
                <td
                  className="bold"
                  style={{ textAlign: 'right', padding: '4px' }}
                >
                  Outbound Check Payee
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div className="col s8 m9 l10">
          <table id="t-values">
            <tbody>
              <tr>
                <td style={{ padding: '4px' }}>{outboundCheckPayee}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div ref={modal} className="modal">
        <div className="modal-content">
          <div className="row">
            <h5 className="center">Edit Accounting Info</h5>
            <div className="divider" />
          </div>
          <div className="row">
            <div className="input-field col s12">
              <input
                id="outboundCheckPayee"
                type="text"
                value={values.outboundCheckPayee}
                onChange={onChange}
              />
              <label htmlFor="outboundCheckPayee">Outbound Check Payee</label>
            </div>
          </div>
          <div className="row">
            <div className="col s12 m4 offset-m4">
              <a
                href="/"
                className="btn-small blue white-text waves-effect waves-light col s12"
                onClick={updateAccountingInfo}
              >
                Save
              </a>
            </div>
            <div className="col s12 m4">
              <a
                href="/"
                className="btn-small white blue-text waves-effect waves-dark col s12"
                onClick={e => {
                  e.preventDefault();
                  setValues(initValues());
                  closeModal();
                }}
              >
                Cancel
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AccountingTab;
